import { combineReducers } from "redux";
import { withProperties, getValueAtPath } from "../../utils";
import withConstantStateFactory from "../helpers/reducers/constant";

export default function state() {
  const NAME = 'customer';
  const $state = Object.create(null);
  const { data } = this;

  const ConstantState = withConstantStateFactory({
    name: __getCustomerName__(),
    email: __getCustomerEmail__()
  });

  const Reducer = combineReducers({
    ...ConstantState
  });

  // Augment $state with properties
  withProperties($state, { NAME, Reducer });

  function __getCustomerName__() {
    const firstname = getValueAtPath(data, 'firstname');
    const lastname = getValueAtPath(data, 'lastname');
    return [firstname, lastname].filter(Boolean).join(' ') || 'Anonymous Customer';
  }

  function __getCustomerEmail__() {
    const email = getValueAtPath(data, 'email');
    const hiddenEmail = getValueAtPath(data, 'preferences[prefers_hidden_email]');
    return hiddenEmail === true ? null : email || null;
  }

  return (state = $state);
}
